import { User, SurveyVersion, SurveyAnswer, DemographicResponses } from '../models';
import { HasId } from '../interfaces';

export class SurveyInstance implements HasId {
    public id: number;
    public uniqueIdentifier: string;
    public user: User;
    public surveyVersion: SurveyVersion;
    public responses: SurveyAnswer[];
    public demographics?: DemographicResponses;
    public active: boolean;

    public completedDate: Date;
    public expirationDate: Date;

    constructor(user: User, surveyVersion: SurveyVersion) {
        this.user = user;
        this.surveyVersion = surveyVersion;
    }
}


// WEBPACK FOOTER //
// ./src/models/SurveyInstance.tsx